export type ChatSelectionResult = Readonly<{
  pendingRequestedChatId: null;
  selectedId: string | null;
}>;

export function resolveSelectedChatId(
  chats: readonly { id: string }[],
  current: string | null,
  requested: string | null,
): string | null {
  if (requested && chats.some((chat) => chat.id === requested)) return requested;
  if (current && chats.some((chat) => chat.id === current)) return current;
  // A normal login/unlock must land on the chat list. Only an explicit deep
  // link/push destination is allowed to select a conversation automatically.
  return null;
}

/**
 * Apply a deep-link chat request exactly once.
 *
 * A push URL may remain in window.location while the app performs periodic
 * refreshes. Returning the request as consumed prevents those later refreshes
 * from overriding a chat that the user selected manually.
 */
export function consumeRequestedChatSelection(
  chats: readonly { id: string }[],
  current: string | null,
  requested: string | null,
): ChatSelectionResult {
  return {
    pendingRequestedChatId: null,
    selectedId: resolveSelectedChatId(chats, current, requested),
  };
}

export function cleanConsumedChatRoute(href: string): string {
  const url = new URL(href, "https://live.jtuc.ru");
  url.searchParams.delete("chat");
  url.searchParams.delete("message");
  url.searchParams.delete("groupCall");
  return `${url.pathname}${url.search}${url.hash}`;
}
